module.exports = __webpack_public_path__ + "static/media/check-circle.eb38d15f.svg";